// extracted by mini-css-extract-plugin
export default {"input":"idk-field_input__mp7ro","inpInner":"idk-field_inpInner__lx2_s"};